// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"ap-z","imageAndVideoCount":"bp-z","imageAndVideoContainer":"cp-z","viewAllReviews":"dp-z"};